export default __webpack_public_path__ + "static/media/bgm-001.c1734d08.mp3";